import { render, staticRenderFns } from "./NewCourseStep2Module.vue?vue&type=template&id=154c7dc9"
import script from "./NewCourseStep2Module.vue?vue&type=script&lang=js"
export * from "./NewCourseStep2Module.vue?vue&type=script&lang=js"
import style0 from "./NewCourseStep2Module.vue?vue&type=style&index=0&id=154c7dc9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports